// context/GlobalProvider.js
import React from 'react';
import { ScrollProvider } from 'context/ScrollContext';
import { NavigationProvider } from 'context/NavigationContext';
import { ContentProvider, useContent } from 'context/ContentContext';
import { CartProvider } from 'context/CartContext';
import { CloverProvider } from 'context/CloverContext';
import { MenuProvider } from 'context/MenuContext';
import { AuthProvider } from 'context/AuthContext';
import { ModalProvider } from 'context/ModalContext';
import { CheckoutProvider } from 'context/CheckoutContext';
import { ToastProvider } from 'context/ToastContext';
import ToastContainer from 'components/ui/ToastContainer';
import LoadingOverlay from 'components/ui/LoadingOverlay';

// Wrapper component to access content loading state
const ContentWrapper = ({ children }) => {
  const { loading } = useContent();

  if (loading) {
    return <LoadingOverlay />;
  }

  return children;
};

const GlobalProvider = ({ children }) => {
  return (
    <ContentProvider>
      <ToastProvider maxToasts={5} defaultPosition="bottom-right">
        <CartProvider>
          <CloverProvider>
            <ModalProvider>
              <MenuProvider>
                <ScrollProvider>
                  <NavigationProvider>
                    <AuthProvider>
                      <CheckoutProvider>
                        <ContentWrapper>
                          {children}
                          <ToastContainer />
                        </ContentWrapper>
                      </CheckoutProvider>
                    </AuthProvider>
                  </NavigationProvider>
                </ScrollProvider>
              </MenuProvider>
            </ModalProvider>
          </CloverProvider>
        </CartProvider>
      </ToastProvider>
    </ContentProvider>
  );
};

export default GlobalProvider;
